export default "__VITE_ASSET__DRA$TmGI__"